
import { atom } from "recoil"

export const AtomColor = atom({
    key:'ATOMCOLOR',
    default:''
})